import React from "react";
import { Tooltip } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useMessage } from "../i18n/locale";

export default function LinkedAccountBadge({ ownerUserId, sx }) {
  const label = useMessage("profileAccountLinked");

  if (!ownerUserId) return null;

  return (
    <Tooltip title={label}>
      <VerifiedIcon
        aria-label={label}
        color="success"
        sx={{ fontSize: "1.1em", flexShrink: 0, verticalAlign: "middle", ...sx }}
      />
    </Tooltip>
  );
}
